import { render, staticRenderFns } from "./compensationInfo.vue?vue&type=template&id=e3525aa4&scoped=true"
import script from "./compensationInfo.vue?vue&type=script&lang=js"
export * from "./compensationInfo.vue?vue&type=script&lang=js"
import style0 from "./compensationInfo.vue?vue&type=style&index=0&id=e3525aa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3525aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3525aa4')) {
      api.createRecord('e3525aa4', component.options)
    } else {
      api.reload('e3525aa4', component.options)
    }
    module.hot.accept("./compensationInfo.vue?vue&type=template&id=e3525aa4&scoped=true", function () {
      api.rerender('e3525aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/compensationInfo.vue"
export default component.exports